import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import React, { ReactNode, useMemo } from 'react';
import { KidIcon, LogoIcon } from '@cp/ds/src/icons';
import { NurseIcon } from '@cp/ds/src/icons/career/common/nurse';

type AdvantageDataProps = {
  renderIcon: () => ReactNode;
  label: string;
};
const ADVANTAGES_DATA_PARAM_DICT: {
  check: (d: CatalogItemViewModel) => boolean;
  viewProps: AdvantageDataProps;
}[] = [
  {
    check: (data) => Boolean(data.clientProfile?.trainingCompletedAt),
    viewProps: {
      renderIcon: () => <LogoIcon />,
      label: 'Школа YouHelp',
    },
  },
  {
    check: (data) => Boolean(data.baby),
    viewProps: {
      renderIcon: () => <KidIcon />,
      label: 'Сидит с младенцами',
    },
  },
  {
    check: (data) => Boolean(data.childWithDisabilities),
    viewProps: {
      renderIcon: () => <NurseIcon />,
      label: 'Сидит с особыми детьми',
    },
  },
];

/**
 * Return advantages config applicable to passed catalogItem
 */
export const useAdvantagesPickedFromData = (data?: CatalogItemViewModel): AdvantageDataProps[] => {
  return useMemo(() => {
    if (!data) {
      return [];
    }
    return ADVANTAGES_DATA_PARAM_DICT.filter(({ check }) => check(data)).map(({ viewProps }) => viewProps);
  }, [data]);
};
